// extracted by mini-css-extract-plugin
export default {"MoveContentsDialog":"MoveContentsDialog_MoveContentsDialog__XyoD1"};